import { useEffect, Component } from "react";
import Lenis from "lenis";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import WhatWeDo from "@/components/WhatWeDo";
import Sectors from "@/components/Sectors";
import Network from "@/components/Network";
import Founder from "@/components/Founder";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

class ErrorBoundary extends Component {
    state = { failed: false };
    static getDerivedStateFromError() {
        return { failed: true };
    }
    render() {
        if (this.state.failed) {
            return (
                <div style={{ padding: 48, fontFamily: "serif" }}>
                    Something went wrong — please refresh the page.
                </div>
            );
        }
        return this.props.children;
    }
}

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <div className="bg-paper text-ink antialiased">
                <div className="grain" aria-hidden="true" />
                <Nav />
                <main>
                    <Hero />
                    <Marquee />
                    <WhatWeDo />
                    <Sectors />
                    <Network />
                    <Founder />
                    <Contact />
                </main>
                <Footer />
            </div>
        </ErrorBoundary>
    );
}

export default App;
